export const SET_LICENSE_CLASSES = "SET_LICENSE_CLASSES";
export const SET_CONCEPTS = "SET_CONCEPTS";
export const SET_REGIONS = "SET_REGIONS";
export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
